var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#C0C0C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4212 -496C-4212 -501.523 -4207.52 -506 -4202 -506H3469C3474.52 -506 3479 -501.523 3479 -496V929C3479 934.523 3474.52 939 3469 939H-4202C-4207.52 939 -4212 934.523 -4212 929V-496Z",
    fill: "#DBDBDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9881_122069)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 997,
    transform: "translate(-1144 -259)",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -883.5,
    y: -101.5,
    width: 1127,
    height: 844,
    rx: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -883.5,
    y: -101.5,
    width: 1127,
    height: 844,
    rx: 5.5,
    stroke: "#D7DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -180.5,
    y: -48.5,
    width: 401,
    height: 201,
    rx: 6.5,
    stroke: "#D7DFE9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8929 23.4289C12.2952 23.4289 11 22.4291 11 20.9631C11 19.4972 12.2952 18.3088 13.8929 18.3088C14.0015 18.3088 14.1087 18.3143 14.2143 18.325V18.3088H14.2541C14.2278 18.1155 14.2143 17.9187 14.2143 17.7189C14.2143 15.1127 16.5168 13 19.3571 13C21.2805 13 22.9573 13.9688 23.8395 15.4036C24.0551 15.3745 24.2756 15.3594 24.5 15.3594C26.9853 15.3594 29 17.2081 29 19.4885C29 21.3657 27.6348 22.7967 25.7656 23.2684M19.858 27V20.2258M19.858 20.2258L16.9062 23.0196M19.858 20.2258L22.8125 23.0196",
    stroke: "#1B4DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9881_122069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 997,
    fill: "white",
    transform: "translate(-1144 -259)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.4d05e8154c2e28b695e8da06e429f276.svg";
export { ForwardRef as ReactComponent };